(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.SidebarService = (function(superClass) {
    extend(SidebarService, superClass);

    function SidebarService(http, rootScope, factory) {
      this.http = http;
      this.rootScope = rootScope;
      this.factory = factory;
      this.getCrops = bind(this.getCrops, this);
      null;
    }

    SidebarService.prototype.getCrops = function() {
      return this.http.post('backend/portal/ratings/load-crops').then(function(response) {
        return response.data;
      }).then((function(_this) {
        return function(response) {
          var crop, i, j, len, props, ref, ref1;
          if (((ref = response.status) != null ? ref.type : void 0) === 'success') {
            ref1 = response.data.crops;
            for (i = j = 0, len = ref1.length; j < len; i = ++j) {
              props = ref1[i];
              crop = _this.factory.make('Crop', props);
              response.data.crops[i] = crop;
            }
          }
          return response;
        };
      })(this));
    };

    return SidebarService;

  })(Service);

}).call(this);
